<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>B/L Actual Info Input</v-card-title>
      <v-card-actions>
        <v-btn @click="save">保存</v-btn>
        <v-btn @click="close">戻る</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                disabled
                label="海外取引先"
                v-model="shipment.partnerName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                disabled
                label="B/L NO"
                v-model="shipment.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                @change="shipment.actualCw = $numberScale2(shipment.actualCw)"
                label="Air C/W Actual"
                v-model="shipment.actualCw"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                @change="shipment.actualGw = $numberScale2(shipment.actualGw)"
                label="G/W Actual"
                v-model="shipment.actualGw"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                @change="shipment.actualM3 = $numberScale3(shipment.actualM3)"
                label="M3 Actual"
                v-model="shipment.actualM3"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['shipment'],
  data() {
    return { selecetd: '', show: false }
  },
  methods: {
    close() {
      this.show = false
      this.$emit('refresh')
    },
    popup() {
      this.show = true
    },
    save() {
      this.$http
        .put(`shipping-advices/${this.shipment.id}/updateActual`, {
          actualGw: this.shipment.actualGw,
          actualCw: this.shipment.actualCw,
          actualM3: this.shipment.actualM3,
        })
        .then(() => {
          return this.$http.post(
            `delivery-orders/create-do?said=${
              this.shipment.id
            }&flag=warehouseTransport&version=${this.shipment.version}`
          )
        })
        .then((res) => {
          if (res.data === true) {
            return this.$http.put(
              `delivery-orders/update-do?said=${
                this.shipment.id
              }&flag=warehouseTransport&version=${this.shipment.version}`
            )
          }
          return true
        })
        .then(() => {
          this.$message('', 'ok')
          this.show = false
          this.$emit('refresh')
        })
    },
  },
}
</script>

<style>
.select-area {
  border: 2px solid #000;
  height: 300px;
}
</style>
